import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const LedgerEntryPanel = ({ entries, onEntrySelect, selectedEntries, onDragStart, suggestedMatches }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredEntries = entries?.filter(entry => {
    return entry?.description?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
           entry?.account?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
           entry?.amount?.toString()?.includes(searchTerm);
  });

  const getSuggestionScore = (entryId) => {
    const suggestion = suggestedMatches?.find(s => s?.ledgerId === entryId);
    return suggestion ? suggestion?.confidence : null;
  };

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border h-full flex flex-col">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-secondary/10 rounded-md flex items-center justify-center">
            <Icon name="BookOpen" size={20} color="var(--color-secondary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-semibold text-base md:text-lg">Ledger Entries</h3>
            <p className="caption text-muted-foreground">
              {filteredEntries?.length} entries
            </p>
          </div>
        </div>

        <Input
          type="search"
          placeholder="Search ledger entries..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e?.target?.value)}
        />
      </div>
      <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-3">
        {filteredEntries?.map((entry) => {
          const suggestionScore = getSuggestionScore(entry?.id);
          
          return (
            <div
              key={entry?.id}
              draggable
              onDragStart={(e) => onDragStart(e, entry, 'ledger')}
              className={`
                p-4 rounded-lg border-2 transition-smooth cursor-move hover-lift
                ${selectedEntries?.includes(entry?.id)
                  ? 'border-secondary bg-secondary/5'
                  : suggestionScore
                  ? 'border-accent/50 bg-accent/5' :'border-border bg-background hover:border-secondary/30'
                }
              `}
              onClick={() => onEntrySelect(entry?.id)}
            >
              {suggestionScore && (
                <div className="flex items-center gap-2 mb-2 pb-2 border-b border-border">
                  <Icon name="Sparkles" size={14} color="var(--color-accent)" />
                  <span className="caption text-accent font-medium">
                    Suggested match ({suggestionScore}% confidence)
                  </span>
                </div>
              )}
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="flex-1 min-w-0">
                  <p className="font-body font-medium text-sm md:text-base text-foreground line-clamp-2">
                    {entry?.description}
                  </p>
                  <p className="caption text-muted-foreground mt-1">
                    {entry?.date} • {entry?.account}
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className={`
                  data-text font-semibold text-base md:text-lg
                  ${entry?.type === 'debit' ? 'text-success' : 'text-error'}
                `}>
                  {entry?.type === 'debit' ? '+' : '-'}${Math.abs(entry?.amount)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
                <span className="caption text-muted-foreground">
                  Ref: {entry?.reference}
                </span>
              </div>
            </div>
          );
        })}

        {filteredEntries?.length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
            </div>
            <p className="font-body text-muted-foreground">No entries found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LedgerEntryPanel;